import { render, staticRenderFns } from "./MangelLocation.vue?vue&type=template&id=f2737e7a&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./MangelLocation.vue?vue&type=script&lang=js&"
export * from "./MangelLocation.vue?vue&type=script&lang=js&"
import style0 from "./MangelLocation.vue?vue&type=style&index=0&id=f2737e7a&prod&lang=css&"
import style1 from "./MangelLocation.vue?vue&type=style&index=1&id=f2737e7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2737e7a",
  null
  
)

export default component.exports